module.exports = __webpack_public_path__ + "static/media/Lucy_Page.9204838b.png";